import { FC, useCallback } from 'react';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import { PANEL_VIEW } from './enum/searchPanelProps';
import TextField from '../form/elements/TextField';
import { TEXT_FIELD_COLOR, TEXT_FIELD_TYPE, TEXT_FIELD_VARIANT } from '../form/enum/formProps';
import { SearchValues } from './model/searchPanelModel';
import { ROUTES } from '../../core/router/routes';
import { setPhrase } from '../../shared/redux/commonSlice';

import './searchPanel.scss';

interface SearchPanelProps {
  view: PANEL_VIEW;
  className?: string;
}

const initialValues: SearchValues = {
  phrase: '',
};

const validationSchema = Yup.object().shape({
  phrase: Yup.string().min(3, 'validation.too_short').max(150, 'validation.too_long'),
});

const SearchPanel: FC<SearchPanelProps> = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const handleSubmit = useCallback((values: SearchValues) => {
    if (values.phrase.length) {
      dispatch(setPhrase(values.phrase));
      history.push(ROUTES.ARTICLE.RESULTS);
    }
  }, []);

  return (
    <div className={'SearchPanel-Wrapper ' + props.className}>
      <h1>{t('search_panel.title')}</h1>
      <h2>{t('search_panel.description')}</h2>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        enableReinitialize={true}
        validateOnChange={false}
      >
        <Form noValidate>
          <TextField
            name="phrase"
            label=""
            placeholder={t('search_panel.placeholder')}
            type={TEXT_FIELD_TYPE.TEXT}
            color={TEXT_FIELD_COLOR.PRIMARY}
            variant={TEXT_FIELD_VARIANT.STANDARD}
            inputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Form>
      </Formik>
    </div>
  );
};

export default SearchPanel;
